module.exports = __webpack_public_path__ + "static/img/2.8e1ac11.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/2.png
// module id = 5XCs
// module chunks = 4